import axiosInstance from '../server/axios';

export const getMessages = async (type) => {
    const response = await axiosInstance.get(`/getmessage/${type}`);
    return response;
};
export const editMessages = async (data) => {
    const response = await axiosInstance.put(`/updatemessage/${data.id}`, data);
    return response;
};
